import { useState } from "react";

import { ErrorMessage } from "@/app/components/error-message";
import { LoadingScreen } from "@/components/loading-screen";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { useOrganisation } from "@/features/select-organisation/api/get-my-organisation";
import { useGetPendingSessions } from "@/features/sessions/api/get-pending-sessions";
import { PendingSessionList } from "@/features/sessions/components/pending-session-list";
import { getOrgSessionStatus } from "@/features/sessions/utils/get-org-session-status";
import { SessionInvitesStatus } from "@classview/shared-types";

export function PendingInvitationsPage() {
  const { organisation } = useOrganisation();
  const [pendingOnly, setPendingOnly] = useState(false);
  const { data, isLoading, isSuccess, isError, error } = useGetPendingSessions(
    {
      organisationId: organisation.id,
    },
    {
      select: (sessions) => {
        if (pendingOnly) {
          return sessions;
        }
        return sessions.filter(
          (session) =>
            getOrgSessionStatus({
              orgId: organisation.id,
              session,
            }) === SessionInvitesStatus.PENDING,
        );
      },
    },
  );

  if (isLoading)
    return (
      <section>
        <LoadingScreen />
      </section>
    );

  if (isError || !isSuccess) {
    return <ErrorMessage error={error} />;
  }

  return (
    <section className="flex max-w-screen-md flex-col">
      <div className="mb-4 ml-auto flex flex-row items-center gap-2">
        <Switch
          id="pending-only"
          checked={pendingOnly}
          onCheckedChange={setPendingOnly}
        />
        <Label htmlFor="pending-only">Show dismissed sessions</Label>
      </div>
      <PendingSessionList sessions={data} />
    </section>
  );
}
